// extracted by mini-css-extract-plugin
export default {"sr-only":"XBvVHj","srOnly":"XBvVHj"};